<template>
  <transition name="dawn-notification">
    <div class="dawn-notification" :class="[type, !icon ? 'no-icon' : '']">
      <div class="icon-wrapper" :class="{ 'no-icon': !icon }">
        <i :class="icon"></i>
      </div>
      <div class="content-wrapper" :class="{ 'no-icon': !icon }">
        <slot v-if="!message" />
        <span v-else>{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'ed-notice',

  props: {
    type: {
      type: String,
      default: 'info',
      validator: val => ~['', 'alt', 'info', 'success', 'warn', 'danger'].indexOf(val)
    },
    icon: {
      type: String,
      default: ''
    },
    message: String
  }
}

</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";

.v-align-center {
  display: flex;
  align-items: center;
}

.dawn-notification {
  position: relative;
  margin: 0.5em 0;
  min-height: 3em;

  @include theme {
    background: v(canvas);
  }

  &.no-icon {
    min-height: 2em;
  }

  @include theme {
    border: 1px solid v(border);

    .icon-wrapper {
      color: v(canvas);
      background: v(border);
      font-size: $font-size-xlarge;
      line-height: 2em;
      padding: 0 0.3em;

      &.no-icon {
        padding: 0 0.1em;
      }

      position: absolute;
      top: 0;
      left: 0;
      min-width: 10px;
      height: 100%;
    }

    &.alt {
      border-color: $primary-alt;
      .icon-wrapper {
        background-color: $primary-alt;
      }
    }

    &.info {
      border-color: v(border);
      .icon-wrapper {
        background-color: v(border);
      }
    }
    &.success {
      border-color: v(tertiary-01);
      .icon-wrapper {
        background-color: v(tertiary-01);
      }
    }
    &.warn {
      border-color: v(attention-01);
      .icon-wrapper {
        background-color: v(attention-01);
      }
    }
    &.danger {
      border-color: v(urgent-01);
      .icon-wrapper {
        background-color: v(urgent-01);
      }
    }
  }

  .content-wrapper {
    padding: 0.5em 0.5em 0.35em 3em;
    font-size: $font-size-small;

    &.no-icon {
      padding-left: 1.5em;
    }
  }
  //
  transition: all .3s ease;
  transform-origin: 0 0;
  overflow: hidden;

  &-enter, &-leave-to {
    transform: scale(1, 0);
    margin-bottom: -3em;
    &.no-icon {
      margin-bottom: -2em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edNotice/index.vue